/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import Res_ColumnMatch from './Res_ColumnMatch';
import Res_MultipleChoice from './Res_MultipleChoice';
import Res_Order from './Res_Order';
import Res_SelectTrue from './Res_SelectTrue';
import Res_Type from './Res_Type';

export default function ResultQuestion(props) {
  const question = props.question;
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  const submissionResults = props.submissionResults;
  //const setSubmission = props.setSubmission;
  var options = JSON.parse(localStorage.getItem('Options'));

  function sortOutResultTypes() {
    var content;
    if (question === undefined || question.type === undefined) return <></>;
    switch (question.type) {
      case 'single':
        content = <Res_MultipleChoice question={question} options = {options} submission={submission} questionNumber={questionNumber} submissionResults={submissionResults} />;
        break;
      case 'multiple':
        content = <Res_SelectTrue question={question} options = {options} submission={submission} questionNumber={questionNumber} submissionResults={submissionResults} />;
        break;
      case 'order':
        content = <Res_Order question={question} options = {options} submission={submission} questionNumber={questionNumber} submissionResults={submissionResults} />;
        break;
      case 'match':
        content = <Res_ColumnMatch question={question} options = {options} submission={submission} questionNumber={questionNumber} submissionResults={submissionResults} />;
        break;
      case 'number':
        content = <Res_Type question={question} options = {options} submission={submission} questionNumber={questionNumber} submissionResults={submissionResults} />;
        break;
      case 'text':
        content = <Res_Type question={question} submission={submission} questionNumber={questionNumber} submissionResults={submissionResults} />;
        break;
      case 'true/false':
        content = <Res_MultipleChoice question={question} options = {options} submission={submission} questionNumber={questionNumber} submissionResults={submissionResults} />;
        break;
    }
    return <>{content}</>;
  }

  return (
    <>
      <link
        href={'https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.9.0/katex.min.css'}
        rel={'stylesheet'}
      />
      {sortOutResultTypes()}
    </>
  );
}
